<div class="flex flex-col gap-2">
  <app-input
    [labelPosition]="labelPosition()"
    [color]="currentColor()"
    [size]="currentSize()"
    [rounded]="currentRounded()"
    [label]="label()"
    [required]="required()"
    [placeholder]="placeholder()"
    [spellcheck]="spellcheck()"
    [autocomplete]="autocomplete()"
    [autofocus]="autofocus()"
    [readonly]="readonly()"
    [type]="currentType()"
    [(value)]="value"
  >
    @if (!hideIcon()) {
      <app-icon
        size="sm"
        [attr.data-theme]="theme()"
        (click)="showPassword.set(!showPassword())"
        class="cursor-pointer theme-text"
        icons
        [name]="icon()"
      />
    }
  </app-input>
  @if (regExp()) {
    <div class="flex gap-2 items-center flex-wrap">
      @if (!testRegExp1()) {
        <div
          class="min-w-max flex gap-2 items-center px-2 py-1 mt-2 text-xs text-red-400 rounded-md bg-red-50 w-max"
        >
          <app-icon size="xs" name="mdi:close" class="text-red-400" />
          <p>8자 이상</p>
        </div>
      }
      @if (!testRegExp2()) {
        <div
          class="min-w-max flex gap-2 items-center px-2 py-1 mt-2 text-xs text-red-400 rounded-md bg-red-50 w-max"
        >
          <app-icon size="xs" name="mdi:close" class="text-red-400" />
          <p>소문자, 숫자 포함</p>
        </div>
      }
      @if (!testRegExp3()) {
        <div
          class="min-w-max flex gap-2 items-center px-2 py-1 mt-2 text-xs text-red-400 rounded-md bg-red-50 w-max"
        >
          <app-icon size="xs" name="mdi:close" class="text-red-400" />
          <p>{{ '특수문자(!, @, #, $, %, 등) 포함' }}</p>
        </div>
      }
    </div>
  }
</div>
